export interface ServerConfig {
  MFE_SERVER?: string;
  MFE_BACKEND_SERVER?: string;
  SESSION_ID?: string;
}

let serverConfig: ServerConfig | undefined;

export function setServerConfig(config: ServerConfig): void {
  console.log('setServerConfig config:', JSON.stringify(config, null, 2));
  serverConfig = config;
}

export function getServerConfig(): ServerConfig {
  return serverConfig || {};
}

/**
 * Get the MFE server Backend/API URL prefix, e.g. https://api.dev.smc.mfe.powerschoolcorp.com
 */
export function getMFEBackendServerURLPrefix(): string {
  const prefix = getServerConfig().MFE_BACKEND_SERVER;

  if (prefix) {
    return prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
  }
  return '';
}
